/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Show_Project_InfoInputs */



/**
* | output |
* | --- |
* | "Show Project Info" |
*
* @param {Editor_Show_Project_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_show_project_info = /** @type {((inputs?: Editor_Show_Project_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Show_Project_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher les informations du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektinformationen anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra informazioni sul progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать информацию о проекте")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar información del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示项目信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト情報を表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट की जानकारी दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar informações do projeto")
	return /** @type {LocalizedString} */ ("Show Project Info")
});